import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from 'services/api';

function saApi() {
  const token = localStorage.getItem('gss_sa_token');
  return { headers: { Authorization: `Bearer ${token}` } };
}

export default function SuperAdminIA() {
  const nav = useNavigate();
  const [stats, setStats] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [testResult, setTestResult] = useState(null);
  const [testing, setTesting] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('gss_sa_token');
    if (!token) { nav('/super-admin/login'); return; }
    Promise.all([
      api.get('/super-admin/ia/stats', saApi()),
      api.get('/super-admin/ia/history', saApi()),
    ]).then(([s, h]) => {
      setStats(s.data);
      setHistory(h.data);
    }).catch(err => {
      if (err.response?.status === 401) { localStorage.removeItem('gss_sa_token'); nav('/super-admin/login'); }
    }).finally(() => setLoading(false));
  }, [nav]);

  const testConnection = async () => {
    setTesting(true);
    setTestResult(null);
    try {
      const r = await api.post('/super-admin/ia/test', {}, saApi());
      setTestResult(r.data);
    } catch (err) {
      setTestResult({ success: false, error: err.message });
    }
    setTesting(false);
  };

  const S = {
    page: { minHeight: '100vh', background: '#0F0F23', padding: '24px 32px', fontFamily: 'Inter, system-ui, sans-serif', color: '#E0E0E0' },
    card: { background: '#1A1A2E', borderRadius: 10, padding: 20, border: '1px solid #2A2A3E' },
    label: { fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 },
    value: { fontSize: 20, fontWeight: 700, color: '#FFF' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 },
    badge: (ok) => ({ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: ok ? '#16A34A20' : '#DC262620', color: ok ? '#16A34A' : '#DC2626' }),
  };

  if (loading) return <div style={S.page}><p style={{ color: '#888' }}>Chargement...</p></div>;

  return (
    <div style={S.page}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 11, color: '#C8A84E', letterSpacing: 4, textTransform: 'uppercase' }}>Super Admin</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#FFF' }}>Configuration IA</div>
        </div>
        <Link to="/super-admin" style={{ color: '#C8A84E', fontSize: 12, textDecoration: 'none' }}>Retour au dashboard</Link>
      </div>

      {/* Config cards */}
      <div style={S.grid}>
        <div style={S.card}>
          <div style={S.label}>Fournisseur</div>
          <div style={S.value}>{stats?.provider || '-'}</div>
        </div>
        <div style={S.card}>
          <div style={S.label}>Modele rapide</div>
          <div style={{ ...S.value, fontSize: 14 }}>{stats?.modelFast || '-'}</div>
        </div>
        <div style={S.card}>
          <div style={S.label}>Modele intelligent</div>
          <div style={{ ...S.value, fontSize: 14 }}>{stats?.modelSmart || '-'}</div>
        </div>
        <div style={S.card}>
          <div style={S.label}>Cache</div>
          <div style={S.value}>
            <span style={S.badge(stats?.cacheEnabled)}>{stats?.cacheEnabled ? 'Actif' : 'Inactif'}</span>
            <span style={{ fontSize: 11, color: '#888', marginLeft: 8 }}>{stats?.cacheTTL}s | {stats?.cacheSize} entrees</span>
          </div>
        </div>
      </div>

      {/* Budget */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 24 }}>
        <div style={S.card}>
          <div style={S.label}>Cout du jour</div>
          <div style={{ ...S.value, color: stats?.dailyCostUSD > stats?.dailyBudget * 0.8 ? '#DC2626' : '#16A34A' }}>
            ${stats?.dailyCostUSD?.toFixed(4) || '0.0000'}
          </div>
          <div style={{ fontSize: 11, color: '#888' }}>Limite : ${stats?.dailyBudget || 5}/jour</div>
          {/* Progress bar */}
          <div style={{ marginTop: 8, height: 4, background: '#2A2A3E', borderRadius: 2, overflow: 'hidden' }}>
            <div style={{
              width: `${Math.min(100, ((stats?.dailyCostUSD || 0) / (stats?.dailyBudget || 5)) * 100)}%`,
              height: '100%', borderRadius: 2,
              background: stats?.dailyCostUSD > stats?.dailyBudget * 0.8 ? '#DC2626' : '#16A34A',
            }} />
          </div>
        </div>

        <div style={S.card}>
          <div style={S.label}>Test connexion IA</div>
          <button onClick={testConnection} disabled={testing} style={{
            marginTop: 8, padding: '8px 20px', borderRadius: 6, border: 'none', cursor: 'pointer',
            background: 'linear-gradient(135deg, #8B1A1A, #C8A84E)', color: '#fff', fontWeight: 600, fontSize: 12,
            opacity: testing ? 0.6 : 1,
          }}>
            {testing ? 'Test en cours...' : 'Tester la connexion'}
          </button>
          {testResult && (
            <div style={{ marginTop: 8 }}>
              <span style={S.badge(testResult.success)}>{testResult.success ? 'Connexion OK' : 'Echec'}</span>
              {testResult.error && <div style={{ fontSize: 10, color: '#DC2626', marginTop: 4 }}>{testResult.error}</div>}
              {testResult.model && <div style={{ fontSize: 10, color: '#888', marginTop: 4 }}>Modele : {testResult.model}</div>}
            </div>
          )}
        </div>

        <div style={S.card}>
          <div style={S.label}>Configuration .env</div>
          <div style={{ fontSize: 11, color: '#888', marginTop: 8, lineHeight: 1.8 }}>
            AI_PROVIDER={stats?.provider}<br/>
            AI_MODEL_FAST={stats?.modelFast}<br/>
            AI_MODEL_SMART={stats?.modelSmart}<br/>
            AI_DAILY_BUDGET_USD={stats?.dailyBudget}<br/>
            AI_CACHE_TTL={stats?.cacheTTL}s
          </div>
        </div>
      </div>

      {/* Recent calls */}
      <div style={S.card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div style={S.label}>Historique des 30 derniers appels IA</div>
        </div>
        {stats?.recentCalls?.length > 0 ? (
          <div className="gss-table-wrap">
          <table style={{ width: '100%', minWidth: 600, borderCollapse: 'collapse', fontSize: 11 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #2A2A3E' }}>
                <th style={{ textAlign: 'left', padding: 6, color: '#888' }}>Date</th>
                <th style={{ textAlign: 'left', padding: 6, color: '#888' }}>Module</th>
                <th style={{ textAlign: 'left', padding: 6, color: '#888' }}>Modele</th>
                <th style={{ textAlign: 'right', padding: 6, color: '#888' }}>Tokens</th>
                <th style={{ textAlign: 'right', padding: 6, color: '#888' }}>Cout</th>
              </tr>
            </thead>
            <tbody>
              {stats.recentCalls.map((c, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #1F1F33' }}>
                  <td style={{ padding: 6, color: '#aaa' }}>{new Date(c.date).toLocaleString('fr-FR')}</td>
                  <td style={{ padding: 6, color: '#E0E0E0' }}>{c.module}</td>
                  <td style={{ padding: 6, color: '#C8A84E' }}>{c.model?.split('-').slice(-2).join('-')}</td>
                  <td style={{ padding: 6, textAlign: 'right', color: '#aaa' }}>{c.tokens}</td>
                  <td style={{ padding: 6, textAlign: 'right', color: '#16A34A' }}>${c.cost?.toFixed(5)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        ) : (
          <p style={{ color: '#666', textAlign: 'center', padding: 20 }}>Aucun appel IA enregistre</p>
        )}
      </div>

      {/* DB History */}
      {history.length > 0 && (
        <div style={{ ...S.card, marginTop: 16 }}>
          <div style={{ ...S.label, marginBottom: 12 }}>Historique DB (30 derniers)</div>
          <div className="gss-table-wrap">
          <table style={{ width: '100%', minWidth: 700, borderCollapse: 'collapse', fontSize: 11 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #2A2A3E' }}>
                <th style={{ textAlign: 'left', padding: 6, color: '#888' }}>Date</th>
                <th style={{ textAlign: 'left', padding: 6, color: '#888' }}>Module</th>
                <th style={{ textAlign: 'left', padding: 6, color: '#888' }}>Question</th>
                <th style={{ textAlign: 'left', padding: 6, color: '#888' }}>Reponse (extrait)</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #1F1F33' }}>
                  <td style={{ padding: 6, color: '#aaa' }}>{new Date(h.created_at).toLocaleString('fr-FR')}</td>
                  <td style={{ padding: 6, color: '#C8A84E' }}>{h.module}</td>
                  <td style={{ padding: 6, color: '#E0E0E0', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{h.question}</td>
                  <td style={{ padding: 6, color: '#888', maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{h.reponse}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      )}
    </div>
  );
}
